import React from 'react'
import Body from './Components/board';
import './App.css';

function App() {
  return (
    <div>

      <Body />
      
    </div>
  );
}

export default App;
